import { render, staticRenderFns } from "./ReviewSessions.vue?vue&type=template&id=455c91e0&scoped=true"
import script from "./ReviewSessions.vue?vue&type=script&lang=js"
export * from "./ReviewSessions.vue?vue&type=script&lang=js"
import style0 from "./ReviewSessions.vue?vue&type=style&index=0&id=455c91e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c91e0",
  null
  
)

export default component.exports